export default "__VITE_ASSET__16354c4f__"